import { render, staticRenderFns } from "@/modules/AccountAsset/templates/asset-property-detail.html?vue&type=template&id=97ac2622&scoped=true&"
import script from "@/modules/AccountAsset/scripts/asset-property-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/AccountAsset/scripts/asset-property-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/AccountAsset/styles/property-detail.scss?vue&type=style&index=0&id=97ac2622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ac2622",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
